'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Thumbnail = require('react-bootstrap/lib/Thumbnail');

var _Thumbnail2 = _interopRequireDefault(_Thumbnail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Thumbnail2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/Thumbnail.js
// module id = 674
// module chunks = 0